export const environment = {
  production: false,
  staging: true,
  apiUrl: 'https://staging.taptimize.com/api',
  appName: 'Taptimize MK2 - Staging',
  version: '1.0.0',
  featureFlags: {
    domainTopics: true,
    crawlManagement: true,
    keywordResearch: true,
    topicShare: true,
    topicDiagnostic: true,
    csvUpload: true,
  },
}; 